import React, { useState, useEffect } from 'react';
import { IconButton, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Carousel from 'react-bootstrap/Carousel';
import ShopStore from '../DataRepo/ShopStore';
import loadingimg from '../Assets/images/loading image 1.png'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { CircularProgress } from '@mui/material';
import { Container, Title, Accordion, rem, createStyles } from '@mantine/core';
import ImageZoom from './ImageZoom';
import useCartStore from '../DataRepo/CartStore';
import { getUserDetails } from '../Auth/AuthUtil';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Badge from '@mui/material/Badge';
import { Skeleton } from '@mui/material';
import addtocart from '../Assets/images/add_to _bag_brown.png'
import WishlistStore from '../DataRepo/WishlistStore';
import FavoriteIcon from '@mui/icons-material/Favorite';

function ReccomedatedProducts() {

    const navigate = useNavigate();

    const userDetails = getUserDetails();
    
    const { addWishlist, WishlistItems, isWishlistLoading, removeWishlist, getWishlistItems } = WishlistStore()
    const { addItem, cartItems, updateQuantity, decreaseQuantity, removeItem, getCart } = useCartStore();
    const { recommedatedproducts, getTopProducts, isRecommendatedProductloading, getrecommedatedProducts, isLoading, Top_Products, getProductsTeaProducts, TeaProducts } = ShopStore();

    useEffect(() => {
        getrecommedatedProducts()
        getWishlistItems()
        getCart()
    }, [])

    const addtoCart = (item, id) => {

        const price = parseInt(item?.price)

        const desc = item?.desc

        const qty = item?.qty

        let product = {
            id: id,
            productName: item?.name,
            quantity: 1,
            price,
            desc,
            companyid: item?.company_id,
            deliverycharges: item?.deliverycharges,
            src: item?.imgurl,
            actualQty: qty,
            sku: item?.sku,
            company: item?.company
        };

        addItem(product, userDetails?.UID)
    }

    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2 items-center justify-between'>
            <div className='flex flex-row items-center'>
                <IconButton onClick={() => navigate(-1)}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Recommended Products</p>
            </div>
            <div>
                <Badge badgeContent={cartItems?.length}
                    onClick={() => {
                        navigate('/Checkout')
                    }}
                    boxSizing="10"
                    sx={{
                        '& .MuiBadge-badge': {
                            backgroundColor: 'red',
                            color: 'red',
                        },
                    }}>
                    <div className='BagIcon'>
                        <img src={addtocart}></img>
                    </div>
                </Badge>
            </div>
        </nav>
        <div className='AllRecommendedProduct-section'>
            <div className='RecommendedProduct-section'>

                <div className='RecommendedProduct-container'>
                    {isRecommendatedProductloading ? (

                        Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className='Product-section-card'>
                                <Skeleton variant="rectangular" width={210} height={118} />
                                <Skeleton width="60%" />
                                <Skeleton width="80%" />
                                <Skeleton width="40%" />
                            </div>
                        ))
                    ) : (
                        recommedatedproducts?.map((product, i) => (
                            <div key={i} className='Product-section-card' onClick={() => navigate(`/Product?id=${product?.id}`)}>

                                <div className="Product-card-header">
                                    <div className="Product-discount-badge">
                                        {product?.orgprice > 0 && product?.orgprice != product?.price ? (
                                            <p>
                                                {(((parseFloat(product?.orgprice) - parseFloat(product?.price)) / parseFloat(product?.orgprice)) * 100).toFixed(0) + "% off"}
                                            </p>
                                        ) : null}
                                    </div>
                                    <div className="Product-wishlist-icon">
                                        <IconButton
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                {
                                                    WishlistItems.some((item) => item.id === product?.id) ? (
                                                        removeWishlist(product?.id)
                                                    ) : (
                                                        addWishlist(product?.id)
                                                    )
                                                }
                                            }}
                                        >
                                            {WishlistItems.some((item) => item.id === product?.id) ? (
                                                <FavoriteIcon style={{
                                                    color: "#DA6E0B"
                                                }} />
                                            ) : (
                                                <FavoriteBorderIcon />
                                            )}
                                        </IconButton>
                                    </div>
                                </div>

                                <div>
                                    <img src={product?.imgurl} alt={product?.name} />
                                </div>

                                <div className='Product-section-card-title'>
                                    <p>{product?.name}</p>
                                    <p>{product?.desc}</p>
                                </div>

                                <div className='Addtobagbutton'>
                                    <div className='Product-section-price-details'>
                                        <p className='mr-5'><del>{product?.orgprice > 0 && product?.orgprice != product?.price ? `₹ ${product?.orgprice}` : ""}</del></p>
                                        <p>₹ {product?.price}</p>
                                    </div>

                                    <div className='w-100'>
                                        <Button
                                            style={{
                                                width: '100%',
                                                display: "block",
                                                textTransform: 'none',
                                                backgroundColor: product.onsale ? '#75623F' : '#D9d9d9',
                                                color: product.onsale ? 'white' : "#A5A39D",
                                                border: 'none',
                                                boxSizing: 'border-box',
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                // padding: "5px"
                                            }}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                if (product.onsale) {
                                                    const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                    const id = product?.id
                                                    !existingItem && addtoCart(product, id)
                                                }

                                            }}
                                        >
                                            <div className="addtobagctn w-100">
                                                {(() => {

                                                    if (product.onsale) {
                                                        const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                        return (
                                                            <div>
                                                                {existingItem ? (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            width: "100%",
                                                                            justifyContent: "space-evenly",
                                                                        }}
                                                                    >
                                                                        <RemoveIcon
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();

                                                                                const id = product?.id?.toString() || product?.id;

                                                                                existingItem.quantity <= 1 ?
                                                                                    removeItem(id) : decreaseQuantity(id, userDetails?.UID);
                                                                            }}
                                                                        />
                                                                        <span style={{ fontSize: "16px" }}>{existingItem.quantity}</span>
                                                                        <AddIcon
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                const id =
                                                                                    product?.id?.toString() || product?.id;
                                                                                updateQuantity(id, userDetails?.UID);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <p>Add to Bag</p>
                                                                )}
                                                            </div>
                                                        );
                                                    } else {
                                                        return <p>Coming Soon</p>;
                                                    }
                                                })()}
                                            </div>

                                        </Button>
                                    </div>

                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>

    </div>
}

export default ReccomedatedProducts